module.exports = __webpack_public_path__ + "static/img/walking-man-orange.a6aa7bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/walking-man-orange.svg
// module id = Iql2
// module chunks = 74